import type { Meta, StoryFn } from '@storybook/react';

import { ThemeOverride, Label } from '@pega/cosmos-react-core';
import type { LabelProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Label',
  component: Label,
  excludeStories: ['ConfigurableLabel']
} as Meta;

export const LabelDemo: StoryFn<LabelProps> = (args: LabelProps) => {
  return <Label labelHidden={args.labelHidden}>Label</Label>;
};

LabelDemo.args = {
  labelHidden: false
};

LabelDemo.argTypes = {
  labelHidden: { control: { type: 'boolean' } }
};

interface ConfigurableLabelProps {
  fontSize?: string;
}

export const ConfigurableLabel: StoryFn<ConfigurableLabelProps> = (
  args: ConfigurableLabelProps
) => {
  return (
    <ThemeOverride
      theme={{
        components: {
          label: {
            'font-size': args.fontSize
          }
        }
      }}
    >
      <Label>Label</Label>
    </ThemeOverride>
  );
};

ConfigurableLabel.args = {
  fontSize: 'xs'
};

ConfigurableLabel.argTypes = {
  fontSize: { options: ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'], control: { type: 'select' } }
};
